/**
 * Create notification documents (arbitium_notifications).
 * Blueprint: arbitium_notifications.json — status: unread | read | dismissed.
 */

import { postRing } from '../core';
import type { NotificationItem } from './get_notifications';

const RING_NOTIFICATIONS = 'arbitium_notifications';

export interface CreateNotificationPayload {
  type?: string;
  title: string;
  details?: string;
  source?: string;
  time?: string;
  status?: 'unread' | 'read' | 'dismissed';
  [key: string]: unknown;
}

/**
 * Creates a new notification. Returns the created item with _id on success.
 */
export async function createNotification(
  payload: CreateNotificationPayload
): Promise<NotificationItem | null> {
  const body: Record<string, unknown> = {
    ...payload,
    status: payload.status ?? 'unread',
  };
  const res = await postRing<NotificationItem>(RING_NOTIFICATIONS, body);
  return res.item ?? null;
}
